"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinePlayers = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLinePlayers = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config?.where_when_who.number_of_golfers;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config?.where_when_who.number_of_guests;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config?.where_when_who.number_of_passengers;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config?.where_when_who.number_of_people;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config?.where_when_who.pax;
        }
    }
    return null;
};
exports.getOrderLinePlayers = getOrderLinePlayers;
